import { Field, Float, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../../action/ActionArgs'
import type { IAction } from '../../../action/IAction'
import type { CouponRedemption } from '../CouponRedemption'

@InputType()
export class RedeemCouponArgs extends ActionArgs {
  /** Claims by the coupon's own `_id`, never `code` — a coupon renamed between purchase and settlement must not orphan an in-flight redemption. */
  @Field(() => ID)
  couponId: string

  /** Whose redemption this is — must agree with whatever `ValidateCoupon` counted against at checkout. */
  @Field(() => String)
  ownerId: string

  @Field(() => ID)
  creditPurchaseId: string

  @Field(() => Float)
  discountApplied: number
}

/**
 * Router-invoked only from `SettleCreditPurchase`, after credits have already been granted — a
 * lost race here (exhaustion or a per-owner conflict) must never throw back to the caller, since
 * the payment is real regardless of whether this particular redemption ends up counted. `null`
 * marks that no redemption was recorded.
 */
export interface IRedeemCoupon extends IAction<CouponRedemption | null, RedeemCouponArgs> {}
